import { cva } from '@/styled-system/css';

export const comboboxClearRecipe = cva({
  base: {
    'display': 'inline-flex',
    'justifyContent': 'center',
    'alignItems': 'center',
    'flexShrink': 0,

    '& > button': {
      marginInline: 'calc(-1 * {spacing.50})',
    },
  },
  variants: {
    size: {
      sm: {
        marginInlineStart: 'tighter',
      },
      md: {
        marginInlineStart: 'tighter',
      },
      lg: {
        marginInlineStart: 'tighter',
      },
    },
  },
});
